import { StatusLabelTypes } from '@factorialco/deprecated-design-system'
import {
  BankingEntitiesPaymentStatusEnum,
  BankingEntitiesTransactionStatusEnum,
  BankingValueObjectsTransferStatusEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export function statusText(
  status:
    | BankingEntitiesPaymentStatusEnum
    | BankingEntitiesTransactionStatusEnum
    | BankingValueObjectsTransferStatusEnum
) {
  switch (status) {
    case 'init':
      return i18n.t('banking.payments.statuses.pending')
    case 'pending_consent':
      return i18n.t('banking.payments.statuses.pending_consent')
    case 'rejected_consent':
      return i18n.t('banking.payments.statuses.rejected_consent')
    case 'in_progress':
      return i18n.t('banking.payments.statuses.in_progress')
    case 'rejected':
      return i18n.t('banking.payments.statuses.failed')
    case 'done':
    case 'paid':
      return i18n.t('banking.payments.statuses.paid')
    case 'partially_paid':
      return i18n.t('banking.payments.statuses.partially_paid')
    default:
      return status satisfies never
  }
}

export function statusLabelType(
  status:
    | BankingEntitiesPaymentStatusEnum
    | BankingEntitiesTransactionStatusEnum
    | BankingValueObjectsTransferStatusEnum
): StatusLabelTypes {
  switch (status) {
    case 'init':
    case 'pending_consent':
    case 'partially_paid':
      return 'warning'
    case 'in_progress':
      return 'info'
    case 'rejected':
    case 'rejected_consent':
      return 'critical'
    case 'done':
    case 'paid':
      return 'positive'
    default:
      return status satisfies never
  }
}
